import { drilldownData, ModuleFields } from "@utils/drilldownData";
import axios from "axios";
import { OptionType } from "~/Components/DynamicForm/DynamicForm";
import { corporateHost } from "~/Utils";

export const fields: any = {
  milestoneOverview: drilldownData["milestoneOverview"].map(
    ({ fieldName, placeholder, name, formType, validation, className, loadOptions, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
    })
  ),
  milestoneLinks: drilldownData["milestoneLinks"]?.map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
    })
  ),


};



